import { render } from "./HeroiconsSolidExclamation.vue?vue&type=template&id=16b8db67"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidExclamation.vue"]])

export default __exports__